
<template>
  <div
    class="count-indicator"
    :class="{'count-indicator--clickable': content.action}"
    @click="action()"
  >
    <div
      v-if="content.icon"
      class="count-indicator__icon"
      :class="{'count-indicator__icon--smaller': content.sizeSmall, 'count-indicator__icon--bigger': content.sizeBig}"
    >
      <svg-loader :src="'/static/images/icon-dashboard-' + content.icon + '.svg'" />
    </div>
    <div
      class="count-indicator__count"
      :class="{'count-indicator__count--smaller': content.sizeSmall,
               'count-indicator__count--bigger': content.sizeBig}"
    >
      <p :class="content.color">
        {{ content.number }}
      </p>
    </div>
    <div
      class="count-indicator__description graphic"
      :class="{'count-indicator__description--bigger': content.sizeBig}"
    >
      <h2>{{ content.text }}</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CountIndicator',
  props: {
    content: {
      icon: {
        type: String
      },
      number: {
        type: String
      },
      text: {
        type: String
      },
      color: {
        type: String
      },
      sizeSmall: {
        type: Boolean,
        default: false
      },
      sizeBig: {
        type: Boolean,
        default: false
      }
    }
  },
  methods: {
    action () {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.count-indicator {
  display: flex;
  justify-items: center;
  flex-direction: row;
  margin-top: 1.6em;
  cursor: default;

  &__icon {
    width: 17%;
    text-align: center;

    .md-icon {
      margin-top: 1px;
    }

    &--smaller {
      width: 12%;
    }

    &--bigger {
      width: 23%;
      margin-right: 0.8em;

      .md-icon {
        width: 30px;
        height: 30px;
        margin-top: -2px;
      }
    }
  }

  &__show-more {
    margin: auto;
    flex: 2;
    text-align: right;
    cursor: pointer;
  }

  &__count {
    min-width: 25%;
    padding-right: 10px;
    margin-bottom: 0.3em;

    &--smaller {
      min-width: 3.2em;

      p {
        text-align: center;
      }
    }

    &--bigger {
      min-width: 70%;
    }

    p {
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: bold;
      font-size: 32px;
      line-height: 26px;
    }
  }

  &__description {
    width: 30%;
    margin: auto 0;

    &--bigger {
      width: 70%;
    }

    h2 {
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 10px;
      line-height: 12px;
      display: flex;
      align-items: center;
      text-transform: uppercase;
      margin: auto;
      color: #7a7a7a;
    }
  }

  &--clickable {
    cursor: pointer;
  }

  .orange {
    color: #f2994a;
  }

  .red {
    color: #e2245a;
  }

  .dark-orange {
    color: #ee5c53;
  }

  .morning-glory {
    color: #8ad4df;
  }

  .light-blue {
    color: #2d9cdb;
  }
  .blue {
    color: #3cc2d9;
  }
  .yellow {
    color: #fe9c4b;
  }
  .green {
    color: #68edae;
  }
}
</style>
